export default __webpack_public_path__ + "static/media/7.a7cd67e5.png";